<template>
  <v-row>
    <v-dialog v-model="dialog.active" persistent width="600">
      <v-card>
        <v-card-title v-if="!isEditView">{{
          $t("components.dialogs.linkedPartnerAddEditDialog.newAffiliate")
        }}</v-card-title>
        <v-card-title v-else>{{ editedItem.name }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.name"
                    :label="
                      $t(
                        'components.dialogs.linkedPartnerAddEditDialog.companyDisplayName'
                      )
                    "
                    color="primary"
                    autocomplete="off"
                    :rules="dealerNameRule"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.company_name"
                    :label="
                      $t(
                        'components.dialogs.linkedPartnerAddEditDialog.companyLegalName'
                      )
                    "
                    color="primary"
                    required
                    autocomplete="off"
                    :disabled="readonlyFields('company_name')"
                    :rules="companyRule"
                  />
                </v-col>
                <!-- <v-col cols="12" sm="12" md="12" lg="12">
                  <brand-selector
                    :brand-uuid.sync="editedItem.brand_uuids"
                    :intial-data="editedItem.brand_uuids"
                  ></brand-selector>
                </v-col> -->
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.address"
                    :label="
                      $t(
                        'components.dialogs.linkedPartnerAddEditDialog.address'
                      )
                    "
                    color="primary"
                    :disabled="readonlyFields('address')"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.city"
                    :label="
                      $t('components.dialogs.linkedPartnerAddEditDialog.city')
                    "
                    color="primary"
                    :disabled="readonlyFields('city')"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <country-selector
                    :initial-country="editedItem.country"
                    @change="editedItem.country = $event"
                    :disabled="readonlyFields('country')"
                  >
                  </country-selector>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.email"
                    :label="
                      $t('components.dialogs.linkedPartnerAddEditDialog.email')
                    "
                    color="primary"
                    autocomplete="off"
                    :rules="emailRules"
                    :hint="
                      $t(
                        'components.dialogs.linkedPartnerAddEditDialog.anEmailWillBeSentToThisEmailAddressWithLoginInstructions'
                      )
                    "
                    persistent-hint
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                        </template>
                        <span>
                          {{
                            $t(
                              "components.dialogs.linkedPartnerAddEditDialog.thisEmailWillBeUsedForSendingOutInvitation"
                            )
                          }}
                          <br />
                          <b
                            >{{
                              $t(
                                "components.dialogs.linkedPartnerAddEditDialog.importantThisInvitationWillAppearInMobileAppWhenABoatOwnerRequestsService"
                              )
                            }}
                          </b>
                        </span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.website"
                    :label="
                      $t(
                        'components.dialogs.linkedPartnerAddEditDialog.website'
                      )
                    "
                    color="primary"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.phone"
                    :label="
                      $t('components.dialogs.linkedPartnerAddEditDialog.phone')
                    "
                    color="primary"
                    autocomplete="off"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="onCancel">{{
            $t("components.dialogs.linkedPartnerAddEditDialog.cancel")
          }}</v-btn>
          <v-btn color="primary" text @click="onSave">{{
            $t("components.dialogs.linkedPartnerAddEditDialog.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CountrySelector from "@/components/selectors/CountrySelector.vue";
import snackbar from "@/utils/snackbar.js";
// import BrandSelector from "@/components/selectors/BrandSelector";

export default {
  components: {
    CountrySelector,
    // BrandSelector,
  },
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      valid: true,
      dealerNameRule: [],
      companyRule: [],
      emailRules: [],
      editedItem: { parent_partner_uuid: this.$route.params.id },
      initialUserEmail: "",
    };
  },
  created() {
    this.setInitialData();
    this.editedItem = { ...this.editedItem, ...this.dialog.editedItem };
    if (this.isEditView) {
      this.initialUserEmail = this.dialog.editedItem.email;
    }
  },
  computed: {
    isEditView() {
      //TODO: refactor
      return false;
    },
  },
  methods: {
    setInitialData() {
      this.dealerNameRule = [
        (v) =>
          !!v ||
          this.$t(
            "components.dialogs.linkedPartnerAddEditDialog.affiliateNameIsRequired"
          ),
      ];
      this.companyRule = [
        (v) =>
          !!v ||
          this.$t(
            "components.dialogs.linkedPartnerAddEditDialog.companyNameIsRequired"
          ),
      ];
      this.emailRules = [
        (v) =>
          /[^@]+@[^.]+\..*/.test(v) ||
          this.$t(
            "components.dialogs.linkedPartnerAddEditDialog.eMailMustBeValid"
          ),
      ];
    },
    readonlyFields(input) {
      return !!this.dialog.readonlyFields.find((element) => element === input);
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.isEditView) {
          this.$emit("save", {
            ...this.editedItem,
            parent_partner_uuid: this.$route.params.id,
            create_initial_user: true,
          });
        } else {
          this.$emit("update", {
            ...this.editedItem,
            parent_partner_uuid: this.$route.params.id,
            create_initial_user:
              this.initialUserEmail === this.editedItem.email,
          });
        }
      } else {
        snackbar.error(
          this.$t(
            "utils.snackbar.error.anErrorHasOccurredPleaseFillInAllTheRequiredFields"
          )
        );
      }
    },
    onCancel() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
